import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Input, Modal, Space, Table, Tooltip, message } from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setBreadcrumbItems } from "../../store/actions";

const Designation = (props) => {
  const [designation, setDesignation] = useState([]);
  const [searchText, setSearchText] = useState("");

  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDesignation, setSelectedDesignation] = useState(null);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  const breadcrumbItems = [
    { title: "Designation", link: "#" },
    { title: "Designation Listing", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems("Designations", breadcrumbItems);
    fetchDesignation();
  }, []);

  const fetchDesignation = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASEURL}/designation`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDesignation(response.data);
    } catch (err) {
      message.error("Failed to load designations");
    }
  };

  const handleDelete = async (designationId, designation) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_BASEURL}/designation/${designationId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      message.success(`Deleted designation: ${designation}`);
      fetchDesignation();
    } catch (err) {
      message.error("Failed to delete designation");
    }
  };

  const columns = [
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => navigate(`/edit-designation/${record._id}`)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="text"
              icon={<DeleteOutlined />}
              style={{ color: PRIMARY_RED }}
              onClick={() => {
                setSelectedDesignation(record);
                setIsModalVisible(true);
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  // Filter designations based on search text
  const filteredData = designation.filter((item) =>
    (item.designation || "").toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <React.Fragment>
      <Row>
        <Col xs="12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <Input
              placeholder="Search designation..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 300 }}
            />
            <Button
              type="primary"
              style={{ backgroundColor: PRIMARY_RED }}
              icon={<PlusOutlined />}
              onClick={() => navigate("/add-designation")}
            >
              Add Designation
            </Button>
          </div>

          <Card>
            <Modal
              title="Delete form"
              visible={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              footer={[
                <Button
                  key="cancel"
                  onClick={() => setIsModalVisible(false)}
                  style={{ backgroundColor: "#6c757d", color: "white" }}
                >
                  Close
                </Button>,
                <Button
                  key="delete"
                  type="primary"
                  style={{ backgroundColor: PRIMARY_RED }}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    handleDelete(selectedDesignation._id, selectedDesignation.designation);
                    setIsModalVisible(false);
                  }}
                >
                  Delete
                </Button>,
              ]}
            >
              <p>
                Are you sure you want to delete{" "}
                <strong>{selectedDesignation?.designation}</strong> designation?
              </p>
            </Modal>

            <CardBody>
              <Table
                columns={columns}
                dataSource={filteredData}
                rowKey="_id"
                pagination={false}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(Designation);
